export const errorMap: Record<number, string> = {
  1: "Successfully processed",
  2: "Client error occurred",
  3: "Unknown error occurred",
  4: "HTTP communication error",
  5: "Authentication has expired",
  6: "Server error occurred",
  7: "Member not found",
  8: "Incorrect password",
  9: "Note not found",
  10: "Invalid input value",
  11: "Attendance record not found",
  12: "Invalid date range",
  13: "Already checked in",
  14: "Email not found",
  15: "Gym not found",
  16: "Manager not found",
  17: "Administrator not found",
  18: "Max manager count exceeded",
  19: "Max news count exceeded",
  20: "News not found",
  21: "Inquiry not found",
  22: "Invalid token",
  23: "Notice not found",
  24: "Gym data insufficient",
  25: "Image not found",
  26: "Already promoted",
};
